export default (amount: number) => {
    const decimalValue = amount/100;
    return decimalValue.toLocaleString("en-GB", {style:"currency", currency:"GBP"});
    //return `£${amount/100}`;
}